import Markdoc, { Config, Schema } from "@markdoc/markdoc";
import { DataSourceType } from "@syla/shared/types/models/DataSourceBase";
import { DataSourceInstructionVariables } from "../../helper/dataSource/getDataSourceInstructions";

export const loginStep: Schema = {
  selfClosing: true,
  transform(_node, config: Config) {
    const variables = config.variables as DataSourceInstructionVariables;

    const dataSourceName = variables.dataSourceName ?? "";
    const dataSourceWebsiteUrl = variables.dataSourceWebsiteUrl;
    const dataSourceType = variables.dataSourceType;

    if (!dataSourceName) {
      return new Markdoc.Tag("span", {}, [`Log in to your account.`]);
    }

    // only provide the link for exchanges, as it doesn't make sense to ask the
    // user to log in to the website for their wallet or blockchain software
    if (dataSourceType === DataSourceType.Exchange && dataSourceWebsiteUrl) {
      return new Markdoc.Tag("span", {}, [
        "Log in to ",
        new Markdoc.Tag(
          "MarkdocLink",
          {
            href: dataSourceWebsiteUrl,
          },
          [dataSourceName],
        ),
        ".",
      ]);
    }

    return new Markdoc.Tag("span", {}, [`Log in to ${dataSourceName}.`]);
  },
};
